import React, { useState } from 'react'
import ModalBasic from '../../component/ModalBasic'
import TextInput from '../../../components/UIComponent/TextInput'
import MultiSelectDropdown from '../../../components/dropdown/MultiSelectDropdown'
import { AgGridReact } from "ag-grid-react";
import PendingWoData from './PendingWoData';

const itemColdefs = [
    {
        field: "drawingNo",
        headerName: "Drawing No",
        minWidth: window.innerWidth * 0.1,
        flex: 1.0,
        filter: true,
    },
    {
        field: "itemType",
        headerName: "Item type",
        minWidth: window.innerWidth * 0.1,
        flex: 1.0,
        filter: true,
    },
    {
        field: "itemDetails",
        headerName: "Item detail",
        minWidth: window.innerWidth * 0.2,
        flex: 1.5,
        filter: true,
    },
    {
        field: "bom",
        headerName: "BOM",
        minWidth: window.innerWidth * 0.06,
        flex: 0.6,
        filter: true,
    },
    {
        field: "quantity",
        headerName: "Qty",
        minWidth: window.innerWidth * 0.06,
        flex: 0.6,
        filter: true,
    },
    {
        field: "currentStock",
        headerName: "Current stock",
        minWidth: window.innerWidth * 0.07,
        flex: 0.8,
        filter: true,
    },
    {
        field: "weight",
        headerName: "Weight",
        minWidth: window.innerWidth * 0.07,
        flex: 0.8,
        filter: true,
    },
    {
        field: "itemRemarks",
        headerName: "Remarks",
        minWidth: window.innerWidth * 0.1,
        flex: 1,
        filter: true,
    },
];

const MaterialProductionPopup = (props) => {
    const [] = useState()
    return (
        <ModalBasic
            id="stock-to-plant"
            classParams="!w-[75%] overflow-y-auto"
            modalOpen={props.isModalOpen}
            setModalOpen={props.setOpenModel}
        >
            <div className='input-fields p-[30px]'>
                <span className="text-blue text-[16px] font-semibold">Material production details</span>
                <div className='item-grp grid grid-cols-5 gap-2.5 mt-3 mb-2 pb-[8px] border-b border-slate-200 items-start'>
                    <div className='input-grp'>
                        <label>Production no</label>
                        <TextInput type='text'
                            id='productionNo' name='productionNo'
                            value={props.productionObject.productionNo}
                            handleChange={(event) => props.handleChange(event, 'productionNo', "production")}
                            className={props.validState?.error?.productionNo !== undefined ? "error" : ""}
                            disabled
                        />
                    </div>
                    <div className='input-grp'>
                        <label>Date</label>
                        <TextInput type='date'
                            id='date' name='date'
                            value={props.productionObject.date}
                            handleChange={(event) => props.handleChange(event, 'date', "production")}
                            className={props.validState?.error?.date !== undefined ? "error" : ""}
                        />
                    </div>
                    <div className='input-grp col-span-2'>
                        <label>Auth employee</label>
                        {/* <MultiSelectDropdown
                            drpIdentity="Select employee"
                            options={props.productionObject.authEmpList}
                            value={props.productionObject.idAuthEmp > 0 ? props.productionObject.authEmpList.find(x => x.value === props.productionObject.idAuthEmp) : 0}
                            onChange={(event) =>
                                props.handleChangeForDropdown(event, "idAuthEmp", "production")
                            }
                            className={props.validState?.error?.idAuthEmp !== undefined ? "error" : ""}
                        /> */}
                        <TextInput type='text'
                            id='usp_Users' name='usp_Users'
                            value={props.usp_Users.find(x => x.globalUserID === props.globalUserID)?.userName || ''}
                            disabled={true}
                        />
                    </div>
                    <div className='input-grp'>
                        <label>Select plant</label>
                        <MultiSelectDropdown
                            drpIdentity="Select plant"
                            options={props.productionObject.plantList}
                            value={props.productionObject.idPlant > 0 ? props.productionObject.plantList.find(x => x.value === props.productionObject.idPlant) : 0}
                            onChange={(event) =>
                                props.handleChangeForDropdown(event, "idPlant", "production")
                            }
                            className={props.validState?.error?.idPlant !== undefined ? "error" : ""}
                        />

                    </div>
                    <div className='input-grp col-span-2'>
                        <label>Select type</label>
                        <MultiSelectDropdown
                            drpIdentity="Select type"
                            options={props.productionObject.typeList}
                            value={props.productionObject.idType > 0 ? props.productionObject.typeList.find(x => x.value === props.productionObject.idType) : 0}
                            onChange={(event) =>
                                props.handleChangeForDropdown(event, "idType", "production")
                            }
                            className={props.validState?.error?.idType !== undefined ? "error" : ""}
                        />
                    </div>
                    <div className='input-grp'>
                        <label>Select number</label>
                        {/* <MultiSelectDropdown
                            drpIdentity="Select number"
                            options={props.productionObject.numberList}
                            value={props.productionObject.idNumber > 0 ? props.productionObject.numberList.find(x => x.value === props.productionObject.idNumber) : 0}
                            onChange={(event) =>
                                props.handleChangeForDropdown(event, "idNumber", "production")
                            }
                            className={props.validState?.error?.idNumber !== undefined ? "error" : ""}
                        /> */}
                        <TextInput
                            id="Select number"
                            name="Select number"
                            value={props.productionObject.woRecvNo}
                            handleOnClick={(event) => props.handleOnClick(event, "numberList")}
                        />
                    </div>
                    <div className='input-grp col-span-2'>
                        <label>Select product</label>
                        {/* <MultiSelectDropdown
                            drpIdentity="Select product"
                            options={props.productionObject.productList}
                            value={props.productionObject.idProduct > 0 ? props.productionObject.productList.find(x => x.value === props.productionObject.idProduct) : 0}
                            onChange={(event) =>
                                props.handleChangeForDropdown(event, "idProduct", "production")
                            }
                            className={props.validState?.error?.idProduct !== undefined ? "error" : ""}
                        /> */}
                        <TextInput
                            id="Select product"
                            name="Select product"
                            value={props.productionObject.productName}
                            handleOnClick={(event) => props.handleOnClick(event, "productList")}
                        />
                    </div>
                    <div className='input-grp'>
                        <label>Quantity</label>
                        <TextInput type='number'
                            id='quantity' name='quantity'
                            value={props.productionObject.quantity}
                            handleChange={(event) => props.handleChange(event, 'quantity', 'production')}
                            className={props.validState?.error?.quantity !== undefined ? "error" : ""}
                            disabled
                        />
                    </div>
                    <div className='input-grp'>
                        <label>Prod. Qty</label>
                        <TextInput type='text'
                            id='prodQty' name='prodQty'
                            value={props.productionObject.prodQty}
                            handleChange={(event) => props.handleChange(event, 'prodQty', 'production')}
                            className={props.validState?.error?.prodQty !== undefined ? "error" : ""}
                        />
                    </div>
                    <div className='input-grp'>
                        <label>Pend Qty</label>
                        <TextInput type='text'
                            id='pentQty' name='pentQty'
                            value={props.productionObject.pentQty}
                            handleChange={(event) => props.handleChange(event, 'pentQty', 'production')}
                            className={props.validState?.error?.pentQty !== undefined ? "error" : ""}
                            disabled
                        />
                    </div>

                    <div className='btn-grp flex gap-2.5 col-span-2 mt-5'>
                        <button className="save-btn btns" onClick={() => props.btnAddBom_Click()}>Add bom data</button>
                        <button className="edit-btn btns" onClick={() => props.setPendingModel()}>Pending data</button>
                    </div>
                </div>
                <span className="text-blue text-[16px] font-semibold">Item details</span>
                <div className='item-grp grid grid-cols-4 gap-2.5 mt-3 mb-2 pb-[8px] border-b border-slate-200 items-start'>
                    <div className='input-grp'>
                        <label>Drawing no</label>
                        <TextInput type='text'
                            id='drawingNo' name='drawingNo'
                            value={props.itemObject.drawingNo}
                            handleChange={(event) => props.handleChange(event, 'drawingNo', 'item')}
                            className={props.validState?.error?.drawingNo !== undefined ? "error" : ""}
                        />
                    </div>
                    <div className='input-grp'>
                        <label>Select type</label>
                        <MultiSelectDropdown
                            drpIdentity="Select type"
                            options={props.itemObject.itemTypeList}
                            value={props.itemObject.idItemType > 0 ? props.itemObject.itemTypeList.find(x => x.value === props.itemObject.idItemType) : 0}
                            onChange={(event) =>
                                props.handleChangeForDropdown(event, "idItemType", "item")
                            }
                            className={props.validState?.error?.idItemType !== undefined ? "error" : ""}
                        />
                    </div>
                    <div className='input-grp col-span-2'>
                        <label>Item name</label>
                        {/* <MultiSelectDropdown
                            drpIdentity="Select itemname"
                            options={props.itemObject.itemList}
                            value={props.itemObject.idItem > 0 ? props.itemObject.itemList.find(x => x.value === props.itemObject.idItem) : 0}
                            onChange={(event) =>
                                props.handleChangeForDropdown(event, "idItem", "item")
                            }
                            className={props.validState?.error?.idItem !== undefined ? "error" : ""}
                        /> */}
                        <TextInput
                            id="Select product"
                            name="Select product"
                            value={props.itemObject.itemName}
                            handleOnClick={(event) => props.handleOnClick(event, "itemList")}
                        />
                    </div>
                    <div className='input-grp'>
                        <label>Quantity</label>
                        <TextInput type='number'
                            id='quantity' name='quantity'
                            value={props.itemObject.quantity}
                            handleChange={(event) => props.handleChange(event, 'quantity', 'item')}
                            className={props.validState?.error?.quantity !== undefined ? "error" : ""}
                        />
                    </div>
                    <div className='input-grp'>
                        <label>Weight</label>
                        <TextInput type='number'
                            id='weight' name='weight'
                            value={props.itemObject.weight}
                            handleChange={(event) => props.handleChange(event, 'weight', 'item')}
                            className={props.validState?.error?.weight !== undefined ? "error" : ""}
                        />
                    </div>
                    <div className='input-grp'>
                        <label>Remarks</label>
                        <TextInput type='text'
                            id='itemRemarks' name='itemRemarks'
                            value={props.itemObject.itemRemarks}
                            handleChange={(event) => props.handleChange(event, 'itemRemarks', 'item')}
                            className={props.validState?.error?.itemRemarks !== undefined ? "error" : ""}
                        />
                    </div>
                    <div className='btn-grp flex gap-2.5 mt-5'>
                        {props.itemObject.keyId > 0 ?
                            <>
                                <button className="edit-btn btns" onClick={() => props.insertItem('Update')}>Update</button>
                                {/* <button className="delete-btn btns" onClick={() => props.deleteItem(props.itemObject.keyId)}>Delete</button> */}
                            </>
                            :
                            <>
                                <button
                                    className="save-btn btns"
                                    onClick={() => props.insertItem('Insert')}
                                    disabled={props.idUser > 0 ? true : false}
                                >Insert</button>
                            </>
                        }

                    </div>
                </div>
                <div className="process-table h-[40vh] mt-2.5">
                    <span className="text-blue text-[16px] font-semibold">Transfer item details</span>
                    <div className="table-inner h-full">
                        <AgGridReact
                            rowData={props.itemRowData}
                            columnDefs={itemColdefs}
                            onRowDoubleClicked={props.handleCellClickItemList}
                        //onGridReady={props.onGridReady}
                        //overlayLoadingTemplate={'<span class="ag-overlay-loading-center">Loading data...</span>'}
                        //overlayNoRowsTemplate="<span'>No Rows To Show</span>"
                        />
                    </div>
                </div>
                <div className='btn-total flex items-end justify-between mt-[35px]'>
                    <div className='btn-grp flex gap-2.5'>
                        <button className="update-btn btns" onClick={() => props.submit()} disabled={props.isSaving}>Save</button>
                        <button className="delete-btn btns" onClick={() => props.close()}>Cancel</button>
                    </div>
                </div>
            </div>

        </ModalBasic>
    )
}

export default MaterialProductionPopup